import {useState} from 'react';
import {ReactComponent as ArrowDownIcon} from '../../assets/common/arrow-down-thick.svg';
import {ReactComponent as ArrowUpIcon} from '../../assets/common/arrow-up-thick.svg';
import styles from './styles/typedropdown.module.css';

export default function TypeDropdown({ chartType, setChartType, setIsMixedChart }) {
    const [openDropdown, setOpenDropdown] = useState(false);

    const chartTypeMap = [
        { name: '막대 그래프', value: 'bar' },
        { name: '선 그래프', value: 'line' },
        { name: '원 그래프', value: 'pie' }
    ];

    const toggleDropdown = () => {
        setOpenDropdown(!openDropdown);
    };

    const clickType = (type) => {
        setChartType(type);
        setOpenDropdown(false);

        if (type === 'pie') setIsMixedChart(false);
    };

    return (
        <div className={styles.wrapper}>
            <button className={styles.btnDropdown} onClick={toggleDropdown}>
                <p>{chartTypeMap.find(type => type.value === chartType)?.name || '그래프 선택'}</p>
                {openDropdown ? <ArrowUpIcon/> : <ArrowDownIcon/>}
            </button>
            {openDropdown &&
                <ul>
                    {chartTypeMap.map((type) => (
                        <li key={type.value}
                            onClick={() => clickType(type.value)}
                        >
                            {type.name}
                        </li>
                    ))}
                </ul>
            }
        </div>
    );
}
